<nav class="navbar navbar-expand-lg fixed-top">
  <div class="container-fluid align-items-end">
    <div class="navbar-brand d-flex align-items-start position-relative bf-logo-slogan-background"
         [class.bf-logo-slogan-background-transparent]="!navbarCollapsed()">
      <a routerLink="/" (click)="closeNavbar()">
        <div class="bf-logo-background">
          <img ngSrc="assets/images/bf-logo.svg" class="bf-logo" alt="Bactoforce Logo" i18n-alt
               priority width="200" height="201"/>
        </div>
      </a>
      <img ngSrc="assets/images/bf-slogan.svg" class="bf-slogan" alt="Bactoforce Slogan" i18n-alt
           priority width="294" height="22"/>
    </div>
    <button type="button" class="navbar-toggler align-self-center border-0" (click)="toggleNavbar()"
            aria-controls="navbar" [attr.aria-expanded]="navbarCollapsed() ? 'false' : 'true'"
            aria-label="Toggle navigation" i18n-aria-label>
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbar" [(ngbCollapse)]="navbarCollapsed">
      <ul class="navbar-nav navbar-nav-scroll gap-0 gap-lg-1 mt-5 mt-lg-0">
        @for (menuItem of menuItems(); track menuItem.id) {
          @if (menuItem.children.length === 0) {
            <li class="nav-item">
              <a class="nav-link" [routerLink]="menuItem.route" routerLinkActive="active"
                 [routerLinkActiveOptions]="routerLinkActiveOptions" (click)="closeNavbar()">
                <ng-container [ngTemplateOutlet]="tmplMenuItemLabel" [ngTemplateOutletContext]="{$implicit: menuItem}"/>
              </a>
            </li>
          } @else {
            <li class="nav-item dropdown" routerLinkActive [routerLinkActiveOptions]="routerLinkActiveOptions"
                #routerLinkActive="routerLinkActive">
              <a href="#" role="button" class="nav-link dropdown-toggle" [class.active]="routerLinkActive.isActive"
                 data-bs-toggle="dropdown" aria-expanded="false">
                <ng-container [ngTemplateOutlet]="tmplMenuItemLabel" [ngTemplateOutletContext]="{$implicit: menuItem}"/>
              </a>
              <ul class="dropdown-menu dropdown-menu-end">
                @for (child of menuItem.children; track child.id) {
                  <li>
                    @if (child.action; as action) {
                      <button type="button" class="dropdown-item" [class.link-danger]="action.isDestructive"
                              [disabled]="action.isBeingHandled()" [rfLoadingIndicator]="action.isBeingHandled()"
                              (click)="handleAction(action)">
                        <ng-container [ngTemplateOutlet]="tmplMenuItemLabel" [ngTemplateOutletContext]="{$implicit: child}"/>
                      </button>
                    } @else {
                      <a role="button" class="dropdown-item" [routerLink]="child.route" routerLinkActive="active"
                         [routerLinkActiveOptions]="routerLinkActiveOptions" (click)="closeNavbar()">
                        <ng-container [ngTemplateOutlet]="tmplMenuItemLabel" [ngTemplateOutletContext]="{$implicit: child}"/>
                      </a>
                    }
                  </li>
                }
              </ul>
            </li>
          }
        }

        <li class="nav-item dropdown">
          <a href="#" role="button" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
             aria-expanded="false" aria-label="Choose language" i18n-aria-label>
            <rf-flag-icon [languageCode]="currentLanguageCode"/>
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            @for (language of languages.valueOrDefault(); track language.value) {
              <li>
                <button type="button" class="dropdown-item"
                        [class.active]="language.value === currentLanguageCode"
                        (click)="changeLanguage(language.value)">
                  <rf-flag-icon [languageCode]="language.value" [languageName]="language.label"/>
                </button>
              </li>
            }
          </ul>
        </li>
      </ul>

      <ng-template #tmplMenuItemLabel let-menuItem [rfContextType]="MenuItemCtx">
        <div class="d-inline-flex gap-2" [ngbTooltip]="menuItem.tooltip">
          @if (menuItem.icon) {
            <i [rfBsIcon]="menuItem.icon"></i>
          }
          @if (menuItem.title) {
            <span>{{ menuItem.title }}</span>
          }
        </div>
      </ng-template>
    </div>
  </div>
</nav>
